import { db, storage } from '../../firebase/firebase'
import {
  collection,
  addDoc,
  Timestamp,
  DocumentReference,
  DocumentData,
  CollectionReference,
  serverTimestamp,
} from 'firebase/firestore'
import leaveRequestServiceConfigs from './configs'
import { LeaveRequestCreateSchema } from '../../database/validations/LeaveRequestCreate'
import { deleteObject, getDownloadURL, ref, StorageReference, uploadBytes } from 'firebase/storage'
import { LeaveRequestRaw } from '../../database/tables'
import DateHelper from '../../helpers/date-helper'

export default async function addLeaveRequest(
  data: LeaveRequestCreateSchema,
): Promise<DocumentReference<LeaveRequestRaw, DocumentData>> {
  return new Promise(async (resolve, reject) => {
    let supportingDocumentRef: StorageReference | null = null
    let supportingDocumentUrl: string | null = null

    try {
      if (!!data.supportingDocument) {
        const storageRef = ref(
          storage,
          `${leaveRequestServiceConfigs.collectionName}/${data.source}-${new Date().getTime()}-${data.supportingDocument.name}`,
        )
        await uploadBytes(storageRef, data.supportingDocument).then(async snapshot => {
          supportingDocumentRef = snapshot.ref
          await getDownloadURL(snapshot.ref)
            .then(url => (supportingDocumentUrl = url))
            .catch(e => {
              throw e
            })
        })
      }

      const currCollection = collection(
        db,
        leaveRequestServiceConfigs.collectionName,
      ) as CollectionReference<LeaveRequestRaw>
      const docRef = await addDoc(currCollection, {
        source: data.source,
        approvalStatus: data.approvalStatus,
        name: data.name,
        email: data.email.toLowerCase(),
        accountTeam: data.accountTeam,
        position: data.position,
        startDate: Timestamp.fromDate(DateHelper.toUTCMidnight(data.startDate)),
        startDateString: DateHelper.toLocalDateString(data.startDate),
        endDate: Timestamp.fromDate(DateHelper.toUTCMidnight(data.endDate)),
        endDateString: DateHelper.toLocalDateString(data.endDate),
        leaveTime: data.leaveTime,
        leaveType: data.leaveType,
        otherLeaveType: data.otherLeaveType ?? null,
        supportingDocumentRef: !!supportingDocumentRef ? (supportingDocumentRef as StorageReference).fullPath : null,
        supportingDocumentUrl,
        reason: data.reason ?? '',
        createdAt: serverTimestamp(),
        approvalUpdatedAt: null,
        approvalBy: null,
      })

      return resolve(docRef)
    } catch (e) {
      if (!!supportingDocumentRef) {
        await deleteObject(supportingDocumentRef)
      }

      return reject(e)
    }
  })
}
